import { useLazySession } from "@/app/layout/useLazySession";
import IsAdmin from "@/auth/IsAdmin";
import AdDetailModel from "@/models/AdDetailModel";
import { ApproveAd } from "@/sell/actions/ApproveAd";
import { Alert, Button } from "@mui/material";

export function AdPendingAlert({ ad }: { ad: AdDetailModel }) {
  const { session } = useLazySession();
  return ad.isPendingApproval ? (
    <Alert
      severity="info"
      sx={{
        width: "100%",
      }}
      action={
        IsAdmin(session?.user) && (
          <Button
            color="inherit"
            size="small"
            onClick={async () => {
              await ApproveAd({
                id: ad.id,
              });
              window.location.reload();
            }}
          >
            Approve
          </Button>
        )
      }
    >
      This ad is currently pending approval.{" "}
    </Alert>
  ) : null;
}
